import { Actions } from '../types/actions';
import { INITIALIZE_APPLICATION } from '../types/constants';

export * from './upload';
export * from './offer';

export const initializeApplication = (): Actions => ({
  type: INITIALIZE_APPLICATION,
});
